var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33073 2.33073C4.56931 2.33073 2.33073 4.56931 2.33073 7.33073C2.33073 10.0922 4.56931 12.3307 7.33073 12.3307C10.0922 12.3307 12.3307 10.0922 12.3307 7.33073C12.3307 4.56931 10.0922 2.33073 7.33073 2.33073ZM0.664062 7.33073C0.664062 3.64883 3.64883 0.664062 7.33073 0.664062C11.0126 0.664062 13.9974 3.64883 13.9974 7.33073C13.9974 8.87132 13.4748 10.2899 12.5973 11.4188L17.0867 15.9081C17.4121 16.2336 17.4121 16.7612 17.0867 17.0867C16.7612 17.4121 16.2336 17.4121 15.9081 17.0867L11.4188 12.5973C10.2899 13.4748 8.87132 13.9974 7.33073 13.9974C3.64883 13.9974 0.664062 11.0126 0.664062 7.33073Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.7e806736e026af6d13f99ee2e6c8c427.svg";
export { ForwardRef as ReactComponent };